import { EAN_PREFIX } from "@nano-portal/shared"
import { Address, BankAccount } from "./form/useAcquisitionFormSchema"
import { CircuitBreaker } from "@nano-portal/customers"
import { isNil } from "lodash"

export function formatStreet(address: Pick<Address, "street" | "descriptiveNumber" | "orientationNumber">) {
  return `${address.street} ${address.descriptiveNumber}${
    address.orientationNumber ? `/${address.orientationNumber}` : ""
  }`
}

export function formatCircuitBreaker(circuitBreaker: CircuitBreaker) {
  return `${circuitBreaker.phases} X ${circuitBreaker.capacity}A`
}

export function formatBankAccount(bankAccount: BankAccount) {
  return `${bankAccount.prefix ? `${bankAccount.prefix}-` : ""}${bankAccount.number}/${bankAccount.bankCode}`
}

export function formatOptionalValue(value: string | number | undefined | null) {
  return isNil(value) || value === "" ? "-" : value
}

export function formatEanWithoutPrefix(ean: string) {
  return `${EAN_PREFIX}${ean}`
}
